import script from "./SettingsConnectPhoneNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsConnectPhoneNumber.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsConnectPhoneNumber.vue?vue&type=style&index=0&id=fafb384a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fafb384a"]])

export default __exports__